import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FaBirthdayCake, FaGift, FaHeart, FaStar } from 'react-icons/fa';

const BirthdayCelebration = ({ recipientName, headline, message, closingMessage }) => {
  const [openCard, setOpenCard] = useState(false);

  return (
    <div className="birthday-celebration">
      <motion.div
        initial={{ scale: 0, rotate: -8 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ type: 'spring', stiffness: 220, damping: 18, delay: 0.25 }}
      >
        <h1 className="birthday-celebration-headline">{headline}</h1>
        <div className="birthday-celebration-icons">
          <FaBirthdayCake />
          <FaStar />
          <FaHeart />
        </div>
        <h3 className="birthday-celebration-recipient">For {recipientName}</h3>
      </motion.div>

      <motion.div
        className="birthday-card-shell"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.45 }}
      >
        <div className={`birthday-card-box ${openCard ? 'open' : ''}`} onClick={() => setOpenCard((prev) => !prev)}>
          <div className="birthday-card-cover">
            <p>Tap to {openCard ? 'close' : 'open'} your card</p>
            <motion.div animate={{ scale: [1, 1.18, 1] }} transition={{ duration: 1.8, repeat: Infinity }}>
              <FaGift />
            </motion.div>
          </div>

          <AnimatePresence>
            {openCard ? (
              <motion.div
                className="birthday-card-message"
                initial={{ rotateX: -90, opacity: 0 }}
                animate={{ rotateX: 0, opacity: 1 }}
                exit={{ rotateX: -90, opacity: 0 }}
                transition={{ duration: 0.45 }}
              >
                <p>{message}</p>
                <motion.div
                  animate={{ scale: [1, 1.15, 1] }}
                  transition={{ duration: 1.5, repeat: Infinity }}
                >
                  <FaHeart />
                </motion.div>
              </motion.div>
            ) : null}
          </AnimatePresence>
        </div>
      </motion.div>

      {closingMessage ? <p className="birthday-celebration-closing">{closingMessage}</p> : null}
    </div>
  );
};

export default BirthdayCelebration;
